import decode from "jwt-decode";
//import router from "../router";



export const obtenerUsuario = async (state, payload) => {
    state.token = payload;
    
    if (payload === "") {
      state.usuarioDB = "";
    } else {
      state.usuarioDB = decode(payload);        
      //router.push({ name: "Home" });     
      
    }
  }